import { useState, useEffect } from "react";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function usePageContent(slug) {
  const { language } = useLanguage();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API}/pages/${slug}?lang=${language || "en"}`)
      .then((res) => {
        if (res.data && res.data.slug) setData(res.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [slug, language]);

  return { data, loading };
}
